import React, { useState } from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"
// Data
import { colors, sizes, genders } from "../../data"
// Styles
import {
   Container,
   FilterElement,
   FilterText,
   CheckboxGroup,
   RadioLabel,
   RadioInput,
} from "./Filter.styles"

const Filter = ({ categoryName, filters, setFilters, setSorts }) => {
   const { t } = useTranslation()

   const [filter, setFilter] = useState(filters)
   const [sort, setSort] = useState("latest")

   const handleFilters = (e) => {
      const { name, value } = e.target

      const newFilters = {
         ...filter,
         [name]: value,
      }
      setFilters(newFilters)
      setFilter(newFilters)
   }

   const handleSort = (e) => {
      setSorts(e.target.value)
      setSort(e.target.value)
   }

   return (
      <Container>
         <FilterElement>
            <FilterText>{t("productsPage.select.s1")}</FilterText>
            <CheckboxGroup>
               {colors.map((color) => (
                  <RadioLabel key={color.value}>
                     <RadioInput
                        type="radio"
                        name="mainColor"
                        value={color.value}
                        checked={filter?.mainColor === color.value}
                        onChange={handleFilters}
                     />
                     {t(`productsPage.value.color.${color.translate}`)}
                  </RadioLabel>
               ))}
            </CheckboxGroup>
         </FilterElement>
         <FilterElement>
            <FilterText>{t("productsPage.select.s2")}</FilterText>
            <CheckboxGroup>
               {colors.map((color) => (
                  <RadioLabel key={color.value}>
                     <RadioInput
                        type="radio"
                        name="secondColor"
                        value={color.value}
                        checked={filter?.secondColor === color.value}
                        onChange={handleFilters}
                     />
                     {t(`productsPage.value.color.${color.translate}`)}
                  </RadioLabel>
               ))}
            </CheckboxGroup>
         </FilterElement>
         <FilterElement>
            <FilterText>{t("productsPage.select.s3")}</FilterText>
            <CheckboxGroup>
               {sizes.map((size) => (
                  <RadioLabel key={size.value}>
                     <RadioInput
                        type="radio"
                        name="size"
                        value={size.value}
                        checked={filter?.size === size.value}
                        onChange={handleFilters}
                     />
                     {t(`productsPage.value.size.${size.translate}`)}
                  </RadioLabel>
               ))}
            </CheckboxGroup>
         </FilterElement>
         <FilterElement>
            <FilterText>{t("productsPage.select.s4")}</FilterText>
            <CheckboxGroup>
               {genders.map((gender) => (
                  <RadioLabel key={gender.value}>
                     <RadioInput
                        type="radio"
                        name="gender"
                        value={gender.value}
                        checked={filter?.gender === gender.value}
                        onChange={handleFilters}
                     />
                     {t(`productsPage.value.gender.${gender.translate}`)}
                  </RadioLabel>
               ))}
            </CheckboxGroup>
         </FilterElement>
         <FilterElement>
            <FilterText>{t("productsPage.label.l2")}</FilterText>
            <CheckboxGroup>
               <RadioLabel>
                  <RadioInput
                     type="radio"
                     value="latest"
                     onChange={handleSort}
                     checked={sort === "latest"}
                  />
                  {t("productsPage.value.sort.s1")}
               </RadioLabel>
               <RadioLabel>
                  <RadioInput
                     type="radio"
                     value="name"
                     onChange={handleSort}
                     checked={sort === "name"}
                  />
                  {t("productsPage.value.sort.s2")}
               </RadioLabel>
               {categoryName !== "optical" ? (
                  <>
                     <RadioLabel>
                        <RadioInput
                           type="radio"
                           value="asc"
                           onChange={handleSort}
                           checked={sort === "asc"}
                        />
                        {t("productsPage.value.sort.s3")}
                     </RadioLabel>
                     <RadioLabel>
                        <RadioInput
                           type="radio"
                           value="desc"
                           onChange={handleSort}
                           checked={sort === "desc"}
                        />
                        {t("productsPage.value.sort.s4")}
                     </RadioLabel>
                  </>
               ) : (
                  <></>
               )}
               <RadioLabel>
                  <RadioInput
                     type="radio"
                     value="sales"
                     onChange={handleSort}
                     checked={sort === "sales"}
                  />
                  {t("productsPage.value.sort.s5")}
               </RadioLabel>
            </CheckboxGroup>
         </FilterElement>
      </Container>
   )
}

Filter.propTypes = {
   categoryName: PropTypes.string,
   filters: PropTypes.object,
   setFilters: PropTypes.func,
   setSorts: PropTypes.func,
}

export default Filter
